import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './Renderer_EncounterEnd.scss';
import { Button, ComponentSync, LL_H_C, LL_V_L, TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import { DispositionRecommendedAction } from '@app/advisor-shared';
import { formatTimestamp, MUSTNeverHappenException } from '@nu-art/ts-common';
import { ModuleFE_Advisor_DiseaseProfile, ModuleFE_EMInterface, ModuleFE_EncounterMetadata, ModuleFE_RuntimeProtocol } from '@app/advisor-frontend';
import { getNoteTemplateId } from '../../../../_utils/get-note-template-id.js';
import { Renderer_DispoDiagnosis } from '../../../components/disposition/renderers/Renderer_DispoToggler/Renderer_DispoDiagnosis.js';
import { ModuleFE_AdvisorMini } from '../../../../modules/ModuleFE_AdvisorMini.js';
import { Component_FocusedProtocol_Mini } from '../../../components/next-steps/focused-protocol/Component_FocusedProtocol_Mini.js';
import { Component_FocusedProtocol } from '../../../components/next-steps/focused-protocol/Component_FocusedProtocol.js';
import { ModuleFE_Spotlight } from '../../../../modules/ModuleFE_Spotlight/index.js';
const dispoStatusToLabel = {
    [DispositionRecommendedAction.ADMIT]: 'Admitted',
    [DispositionRecommendedAction.DISCHARGE]: 'Discharged',
    [DispositionRecommendedAction.ENGAGED_ENCOUNTER]: 'Closed Session'
};
export class Renderer_EncounterEnd extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        const endProtocol = ModuleFE_EMInterface.getEndedProtocol();
        if (!endProtocol) {
            const dispositionData = ModuleFE_EncounterMetadata.getEncounterMetadata()?.dispositionData;
            if (!dispositionData?.diagnosisVariable)
                return state;
            const dispoDP = ModuleFE_Advisor_DiseaseProfile.cache.find(dp => dp.variableId === dispositionData?.diagnosisVariable);
            if (!dispoDP)
                throw new MUSTNeverHappenException('Reached disposition without an end protocol and with no DP connected to the diagnosis variable');
            state.workingDiagnosisDP = dispoDP;
        }
        else {
            const dispoDP = ModuleFE_Advisor_DiseaseProfile.cache.find(dp => dp.variableId === endProtocol.variableIds[0]);
            if (!dispoDP)
                throw new MUSTNeverHappenException('Reached disposition with an end protocol with a variable not connected to a disease profile');
            state.workingDiagnosisDP = dispoDP;
        }
        return state;
    }
    //######################### Logic #########################
    openPhysicianNotes = async () => {
        const noteTemplateId = getNoteTemplateId();
        if (!noteTemplateId)
            return;
        const key = ModuleFE_EMInterface.getSmartNoteStorageKey(noteTemplateId);
        let note = key.get();
        if (!note) { //No note in the key is possible if cache was cleared or this is not the machine that we got to dispo with
            //Get data from EM and put it in the key
            const response = await ModuleFE_EMInterface.vv1.smartNote.get({ noteTemplateId: noteTemplateId }).executeSync();
            key.set(response.note);
            note = response.note;
        }
        if (note) //Only open the notes if we actually have a note here
            ModuleFE_Spotlight.openPhysicianNotes({ note });
    };
    //######################### Render - Dispo type tag #########################
    renderDispoType = () => {
        const dispoStatus = ModuleFE_EncounterMetadata.getEncounterMetadata()?.dispositionData.dispositionDecision; // it can be assumed that this exists, otherwise derive would throw an error
        const label = dispoStatusToLabel[dispoStatus];
        return _jsxs(LL_H_C, { className: 'dispo-type', children: [label, _jsx(Button, { className: 'see-notes-button', onClick: this.openPhysicianNotes, variant: 'primary', children: "See Physician\u2019s Notes" })] });
    };
    //######################### Render - Time Summery #########################
    renderTimeSummery = () => {
        // the time in workup is the last update (disposition completed) of the completed protocol to the creation of the general protocol
        const dispositionInfo = ModuleFE_EncounterMetadata.getEncounterMetadata()?.dispositionData;
        const timestamp = dispositionInfo?.dispositionTimestamp;
        const encounterStartTimestamp = ModuleFE_EncounterMetadata.getEncounterMetadata()?.period?.start;
        const firstLaunchTimestamp = ModuleFE_RuntimeProtocol.getGeneralProtocol()?.__created;
        let timeInWorkup;
        if (!firstLaunchTimestamp) {
            this.logError('Missing general protocol');
            timeInWorkup = 'N/A';
        }
        else if (!timestamp) {
            this.logError('Missing timestamp');
            timeInWorkup = 'N/A';
        }
        else {
            const time = timestamp - (encounterStartTimestamp ?? firstLaunchTimestamp);
            timeInWorkup = `${Math.round(time / 60000)}m`;
        }
        return _jsxs(LL_H_C, { className: 'time-summary', children: [_jsx(TS_PropRenderer.Horizontal, { label: 'Time in Workup', children: timeInWorkup }), _jsx(TS_PropRenderer.Horizontal, { label: 'Disposition Time', children: formatTimestamp('h:mma', timestamp) })] });
    };
    //######################### Render - Working diagnosis #########################
    renderWorkingDiagnosis = () => {
        const dp = this.state.workingDiagnosisDP;
        return _jsx(TS_PropRenderer.Vertical, { className: 'working-diagnosis', label: 'Differentials & Workup', children: dp
                ? _jsx(Renderer_DispoDiagnosis, { diagnosis: dp, onClick: () => {
                    } })
                : 'N/A' });
    };
    //######################### Render - Focused Protocol #########################
    renderFocusedProtocol = () => {
        if (ModuleFE_AdvisorMini.getIsMiniActive()) {
            const focusedProtocol = this.state.focusedProtocol;
            if (!focusedProtocol)
                return;
            return _jsx(Component_FocusedProtocol_Mini, { protocolData: focusedProtocol });
        }
        return _jsx(Component_FocusedProtocol, {});
    };
    render() {
        return _jsxs(LL_V_L, { className: 'encounter-end', children: [this.renderDispoType(), this.renderTimeSummery(), _jsx("p", { className: 'general-message', children: "To add a new order, please go to the regular orders panel." }), this.renderWorkingDiagnosis(), this.renderFocusedProtocol()] });
    }
}
//# sourceMappingURL=Renderer_EncounterEnd.js.map